import React, { useState, useEffect, useCallback } from 'react'
import MainTableRow from './MainTableRow/MainTableRow'
import Stores from 'Stores'
import { localisationMaster } from 'Localisation/Localisation'
import Loader from '../Loader/Loader'
import SubMenu from '../SubMenu/SubMenu'
import listingStore from 'Stores/listingStore'
import { observer } from 'mobx-react'
import './MainTable.scss'
import SlideMenuListing from 'components/ContentBox/Groups/components/SlideMenuListing'
import Card from 'components/ContentBox/Online-schedule/ClientsAfterOnline/Card.jsx'
import { ExcelRowsParams, setCellParams } from 'components/utils/ExcelExport'
import ExportExcelButton from 'components/Modules/Reports/ExportExcelButton/ExportExcelButton'
import { superAxiosRequest } from 'axiosApi'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import { useHistory } from 'react-router-dom'
import Pagination from 'components/UI/Pagination/Pagination'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import Filter from '../Filter/Filter'
import FilterLiner from '../Filter/FilterLiner'
import FilterTextValues from '../../../UI/AsideFilter/FilterTextValues'

const MainTable = (props) => {
  const {
    page,
    perPage,
    setPage,
    setPerPage,
    filterParamsObject,
    dropData,
    setFilterConf,
    filterType,
    filterParamsWithoutPagination,
  } = listingStore

  const data = props.data
  const colsSettings = data.colsSettings

  const [openAllRows] = useState(props.data.colsSettings.is_open)
  const [link, setLink] = useState(null)
  const [subMenu, setSubmenu] = useState(1)
  const [subMenuType, setSubmenuType] = useState(
    props.mulitype_values ? props.mulitype_values[0] : null,
  )
  const [excelData, setExcelData] = useState([])

  const { translate } = useLocalization({
    section: 'user',
    subsection: 'translator',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      search: 'Search',
      search_input: 'Search by student name, surname, or patronymic...',
      date: 'Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      filter: 'Filter',
      text: 'Text',
    },
  })

  const [filter, updateFilter] = useLocalStorageFilter()

  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const history = useHistory()

  const handleSearch = (text) => {
    const queryParam = data.searchQueryName || 'search'
    updateFilter({ ...filter, [queryParam]: text })
    changeTextValue(queryParam, {
      key: queryParam,
      label: data.placeholderSearchInput || 'Search',
      value: text,
    })
  }
  const handleSearchClear = () => {
    if (!filter) return

    const queryParam = data.searchQueryName || 'search'
    const { [queryParam]: _, ...obj } = filter
    updateFilter(obj)
    setTextValues(filterTextValues.filter((field) => field.key !== queryParam))
  }

  const [lastRequestParams, setLastRequestParams] = useState(null)

  const getData = useCallback(() => {
    const params = {
      offset: (page - 1) * perPage,
      limit: perPage,
      ...filter,
      ...(props.filter_by_id && props.id && { [props.filter_by_id]: props.id }),
      ...(props.apiParams && { ...props.apiParams }),
      ...(props.surfMenu && { filter_type: filterType }),
      ...(props.multitype && { [subMenuType]: subMenu }),
    }

    // Проверяем, изменились ли параметры
    if (JSON.stringify(params) === JSON.stringify(lastRequestParams)) {
      return
    }

    setLastRequestParams(params)

    const apiConf = {
      method: 'get',
      link: colsSettings['prefix'] + '/' + colsSettings['link'],
      params: { ...filterParamsObject, ...params },
    }

    listingStore.fillData(apiConf)
  }, [page, perPage, filter, subMenu, subMenuType, lastRequestParams])

  const drop = (isDataDroped) => {
    if (isDataDroped) {
      listingStore.dropDataForDelete(data)
      setPage(1)
      setPerPage(10)
      getData()
    }
    updateFilter({})
    closeFilter()
  }

  const myChangeState = (value, type) => {
    setSubmenu(value)
    setSubmenuType(type)
  }

  const handleFilterChange = (newFilterParams) => {
    const transformedParams = {
      ...newFilterParams,
    }
    updateFilter(transformedParams)
  }

  const excelExportData = async () => {
    const apiConf = {
      method: 'get',
      link: colsSettings['prefix'] + '/' + colsSettings['link'],
      params: {
        offset: 0,
        limit: 9999,
        ...filter,
        ...filterParamsWithoutPagination,
        ...(props.filter_by_id &&
          props.id && { [props.filter_by_id]: props.id }),
        ...(props.apiParams && { ...props.apiParams }),
      },
    }

    const response = await superAxiosRequest(apiConf)
    return response.data.result
  }

  const handleExportExcel = async () => {
    const fetchedData = await excelExportData()
    setExcelData(fetchedData)

    downloadExcel(fetchedData, data.link)
  }

  const exportTemplates = {
    'student-discount'(excelData) {
      import('xlsx-js-style').then((XLSX) => {
        let headRow = [
          {
            v: 'Ф.И.О. студента',
          },
          {
            v: 'Группа',
          },
          {
            v: 'Cкидка',
          },
        ]
        headRow = setCellParams(headRow, ExcelRowsParams.headerRowParam)

        let tableData = []

        let merges = []
        let wscols = [{ wch: 30 }, { wch: 30 }, { wch: 30 }]
        let rows = [{ hpx: 30 }]

        excelData.forEach((studentItem) => {
          tableData.push([
            {
              v: `${studentItem.student_name}`,
              ...ExcelRowsParams.tableRowParam.firstCell,
            },
            {
              v: `${studentItem.group_name}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${studentItem.discount_name}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
          ])
        })

        let wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
        ws['!cols'] = wscols
        ws['!merges'] = merges
        ws['!rows'] = rows
        XLSX.utils.book_append_sheet(wb, ws, 'List 1')

        XLSX.writeFile(wb, 'Клиенты со скидками.xlsx')
      })
    },
    debetors(excelData) {
      import('xlsx-js-style').then((XLSX) => {
        let headRow = [
          {
            v: 'Ф.И.О. студента',
          },
          {
            v: 'Группа',
          },
          {
            v: 'Долг',
          },
        ]
        headRow = setCellParams(headRow, ExcelRowsParams.headerRowParam)

        let tableData = []

        let merges = []
        let wscols = [{ wch: 30 }, { wch: 30 }, { wch: 30 }]
        let rows = [{ hpx: 30 }]

        excelData.forEach((studentItem) => {
          tableData.push([
            {
              v: `${studentItem.student.first_name} ${studentItem.student.last_name}`,
              ...ExcelRowsParams.tableRowParam.firstCell,
            },
            {
              v: `${studentItem.group.name}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${Stores.cleanSumm(studentItem.group_balance / 100)} тг`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
          ])
        })

        let wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
        ws['!cols'] = wscols
        ws['!merges'] = merges
        ws['!rows'] = rows
        XLSX.utils.book_append_sheet(wb, ws, 'List 1')

        XLSX.writeFile(wb, 'Список должников.xlsx')
      })
    },
    'cert-in-group'(excelData) {
      import('xlsx-js-style').then((XLSX) => {
        let headRow = [
          {
            v: 'Ф.И.О. студента',
          },
          {
            v: 'Группа',
          },
          {
            v: 'Баланс сертификата',
          },
        ]
        headRow = setCellParams(headRow, ExcelRowsParams.headerRowParam)
        let tableData = []

        let merges = []
        let wscols = [{ wch: 30 }, { wch: 30 }, { wch: 30 }]
        let rows = [{ hpx: 30 }]

        excelData.forEach((studentItem) => {
          tableData.push([
            {
              v: `${studentItem.student_certificate.student.name}`,
              ...ExcelRowsParams.tableRowParam.firstCell,
            },
            {
              v: `${studentItem.group_name}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${Stores.cleanSumm((studentItem.student_certificate.amount * 100 - studentItem.student_certificate.debited) / 100)}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
          ])
        })

        let wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
        ws['!cols'] = wscols
        ws['!merges'] = merges
        ws['!rows'] = rows
        XLSX.utils.book_append_sheet(wb, ws, 'List 1')

        XLSX.writeFile(wb, 'Список студентов с сертификатами.xlsx')
      })
    },
  }

  const downloadExcel = (excelData, exportTemplate) => {
    exportTemplates[exportTemplate](excelData)
  }

  useEffect(() => {
    let apiConf = {
      method: 'get',
      link: colsSettings['prefix'] + '/' + colsSettings['link'],
    }
    !!props.apiParams && setFilterConf(apiConf, props.apiParams)
    props.thisPage === link ? getData() : dropData()
  }, [perPage, page]) //eslint-disable-line

  useEffect(() => {
    if (props.thisPage !== link) {
      listingStore.data = []
      setLink(props.thisPage)
      listingStore.setPage(1)
    }
  }, [link, props.thisPage])

  useEffect(() => {
    listingStore.dropData()
    return () => {
      listingStore.dropData()
    }
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/c/company/clients-profiles') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  useEffect(() => {
    const timer = setTimeout(() => {
      getData()
    }, 300)

    return () => clearTimeout(timer)
  }, [filter, page, perPage, subMenu, subMenuType])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'filter') {
        const storedFilter = localStorage.getItem('filter')
        updateFilter(storedFilter ? JSON.parse(storedFilter) : {})
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [updateFilter])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== `/${data.filterPage}`) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <>
      {colsSettings.newFilter && (
        <>
          <div className='main-table__filter'>
            <SearchBooks
              onSearch={handleSearch}
              onClear={handleSearchClear}
              placeholder={
                data.placeholderSearchInput ||
                localisationMaster('search', 'searchGlobal')
              }
              value={filter?.[data.searchQueryName || 'search'] || ''}
              translate={translate}
            />
          </div>

          {isOpenFilter && (
            <AsideFilter
              getFilterParams={handleFilterChange}
              config={props.config}
              filterValue={filter}
              onDropFilter={drop}
              translate={translate}
              showLabel={false}
            />
          )}
          {!!filterTextValues.length && (
            <div style={{ padding: '0px 20px' }}>
              <FilterTextValues
                onDelete={(key) => {
                  const { [key]: _, ...obj } = filter
                  updateFilter(obj)
                }}
              />
            </div>
          )}
        </>
      )}

      {props.filter && (
        <Filter
          link={props.filterLink}
          drop={drop}
          config={props.config}
          setPage={setPage}
          subMenu={subMenu}
          thisPage={props.thisPage}
        />
      )}
      {props.filterLiner && (
        <FilterLiner
          link={props.filterLinerLink}
          drop={drop}
          config={props.config}
          setPage={setPage}
          subMenu={subMenu}
          thisPage={props.thisPage}
          getFilterValue={false}
          baseApi={{
            ...props.apiParams,
            ...(props.filter_by_id &&
              props.id && { [props.filter_by_id]: props.id }),
          }}
        />
      )}

      <div className='main-table__container'>
        {props.multitype ? (
          <SubMenu
            titles={props.mulitype_values}
            myChangeState={myChangeState}
          />
        ) : null}
        {props.surfMenu ? (
          <SlideMenuListing
            list={Stores.observableArray(listingStore.meta).group_statuses}
            link={props.filterLink || props.filterLinerLink}
          />
        ) : null}
        <div className='main-table__count'>
          {localisationMaster('text_2', 'online-schedule/clients-after-online')}{' '}
          {listingStore.meta.count_items}
        </div>

        {listingStore.loading ? (
          <Loader />
        ) : props.thisPage === link &&
          Stores.observableArray(listingStore.data).length > 0 ? (
          <>
            {data.exportToExcel && excelData && (
              <div style={{ padding: '10px' }}>
                <ExportExcelButton
                  data={excelData}
                  downloadExcel={handleExportExcel}
                />
              </div>
            )}
            {Stores.observableArray(listingStore.data).length > 0 ? (
              Stores.observableArray(listingStore.data).map((item, index) =>
                colsSettings.is_slot && item ? (
                  <Card items={item} key={index} drop={() => {}} />
                ) : (
                  <MainTableRow
                    items={item}
                    openAllRows={openAllRows}
                    colsSettings={colsSettings}
                    drop={drop}
                    index={index}
                    key={index}
                    pays={props.pays}
                    paysButton={props.paysButton}
                    data={data}
                    paysScore={props.paysScore}
                    updateRow={listingStore.updateRow}
                    getData={getData}
                  />
                ),
              )
            ) : props.errorText ? (
              <div className='groups-listing-header'>{props.errorText}</div>
            ) : null}
          </>
        ) : (
          <div className='main-table__empty-result'>
            {localisationMaster('text_48', 'study/study-test')}
          </div>
        )}
      </div>

      <div className='main-table__pagination'>
        <Pagination
          limit={10}
          count={listingStore.meta.count_items || 0}
          page={page}
          onChange={setPage}
          onChangePerPage={setPerPage}
        />
      </div>
    </>
  )
}

export default observer(MainTable)
